import { UserGender } from "../models";
import { APP_ROUTES, TEXT } from "../constants";

export const AgentUtil = {
  buildAgentDetailPath,
  getGender,
};

function buildAgentDetailPath(agentId: string): string {
  return agentId ? APP_ROUTES.AGENT.AGENT_DETAIL.replace(":agentId", agentId) : APP_ROUTES.AGENT.BASE;
}

function getGender(genderStatus: UserGender): string {
  let gender: string = TEXT.EMPTY;

  switch (genderStatus) {
    case UserGender.MAN:
      gender = "Nam";
      break;
    case UserGender.WOMAN:
      gender = "Nữ";
      break;

    default:
      break;
  }

  return gender;
}
